import Component from '../../shared/component';

export default class InformationModal extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);

    this.bindEvents();
    this.showModal();
  }

  bindEvents() {
    this.handleModalShow = this.handleModalShow.bind(this);

    this.$element.on('show.bs.modal.InformationModal', this.handleModalShow);
  }

  unbindEvents() {
    this.$element.off('show.bs.modal.InformationModal', this.handleModalShow);
  }

  showModal() {
    this.$element.modal('show');
  }

  markModalAsRead() {
    // To be overriden
  }

  handleModalShow() {
    this.markModalAsRead();
  }
}
